






import { Vue, Prop, Component } from "vue-property-decorator";
import { AnalyticsEvent } from "../variables/trackingAnalytics.js";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare var wpcf7: any;

@Component
export default class Formulaire extends Vue {
  @Prop() private form!: string;

  //* *** Ici on ajoute les valeurs récupérée tout au long du tunnel pour les ajouter dans les hidden field du form */
  addValueToHiddenField(): void {
    const formContainer = document.querySelector(".form-tunnel");
    if (formContainer) {
      const hiddeFields = document.querySelectorAll(".hidden-tunnel");
      if (hiddeFields) {
        hiddeFields.forEach((hidden) => {
          const hiddenCast = hidden as HTMLInputElement;
          const hiddenID = hidden.id;
          if (hiddenID) {
            switch (hiddenID) {
              /// Switch sur le nom des hidden field à changer au besoin
              case "projet":
                hiddenCast.value = this.$store.getters.getValueForStep1;
                break;
              case "style":
                hiddenCast.value = this.$store.getters.getValueForStep2;
                break;
              case "caracteristique":
                hiddenCast.value = this.$store.getters.getValueForStep3;
                break;
              case "chambres":
                hiddenCast.value = this.$store.getters.getValueForStep3Radio;
                break;
              case "annexes":
                hiddenCast.value = this.$store.getters.getValueForStep3Options;
                break;
              case "surface":
                hiddenCast.value = this.$store.getters.getValueForStep3Surface;
                break;
              case "terrain":
                hiddenCast.value = this.$store.getters.getValueForStep4;
                break;
              case "departement":
                hiddenCast.value = this.$store.getters.getStep4Departement;
                break;
              case "budget":
                hiddenCast.value = this.$store.getters.getValueForStep5;
                break;
              default:
                break;
            }
          }
        });
      }
      // En plus on déclanche les évent en lien avec le formulaire
      this.eventForm();
    }
  }

  // Pour camif -> Certains champs du form sont masqué par defaut (à supprimer celon le projet)
  // Event du formulaire => au submit on redirige vers la dernière vue du tunnel
  eventForm(): void {
    const form = document.querySelector(
      ".form-tunnel .init"
    ) as HTMLFormElement;

    if (form) {
      // eslint-disable-next-line no-undef
      if (typeof wpcf7.initForm === "function") {
        // eslint-disable-next-line no-undef
        wpcf7.initForm(form);
      } else {
        // eslint-disable-next-line no-undef
        wpcf7.init(form);
      }
      document.addEventListener(
        "wpcf7mailsent",
        function (event) {
          //Affichage du message de confirmation selon le formulaire
          const analytics = {
            category: "Formulaire",
            action: "Remerciement",
            label: "Configurateur",
          };
          new AnalyticsEvent(analytics as any);
        },
        false
      );

      document.addEventListener(
        "wpcf7mailsent",
        (e) => {
          //Une fois que le form est envoyé, on redirige l'utilisateur sur la vue final
          this.$router.push({ name: "Final" });
        },
        false
      );

      // form.addEventListener(
      //   "wpcf7submit",
      //   () => {
      //     console.log("pouet");
      //     // Une fois que le form est envoyé, on redirige l'utilisateur sur la vue final
      //     this.$router.push({ name: "Final" });
      //   },
      //   false
      // );
      // Affichage du message de confirmation selon le formulaire
    }
  }

  /***
   * VUE STATE =>
   */
  mounted(): void {
    if (this.form) {
      this.addValueToHiddenField();
    }
  }
}
